import { Box, Flex } from '@chakra-ui/react';
import { ReactElement } from 'react';
import { Card, CardBody, Checkbox } from 'ui-components';

type CheckboxCardProps = {
  isChecked: boolean;
  onChange: (val: boolean) => void;
  isDisabled?: boolean;
  children: ReactElement;
};

// Force this component to be controlled - otherwise causes issues with checked state ui
export const CheckboxCard = ({
  isChecked,
  onChange,
  isDisabled,
  children,
}: CheckboxCardProps) => {
  return (
    <Card
      padding="14px 24px"
      borderColor={isChecked ? 'secondary.400' : 'primary.100'}
      _hover={{
        cursor: 'pointer',
        borderColor: isChecked ? 'secondary.400' : 'primary.100',
      }}
      pointerEvents={isDisabled ? 'none' : undefined}
      opacity={isDisabled ? 0.7 : 1}
      as="label"
    >
      <CardBody>
        <Flex alignItems="center" gap={6}>
          <Box flex="1">{children}</Box>
          <Checkbox
            isChecked={isChecked}
            onChange={onChange}
            isDisabled={isDisabled}
          />
        </Flex>
      </CardBody>
    </Card>
  );
};
